module.exports = __webpack_public_path__ + "static/media/chevron-up.584c0af8.svg";